import React, { useCallback, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { StandardGrid } from '../../Grid';
import { getStreamItemId } from '../../Duperbrowse/redux/helpers';
import StandardThumb from '../../DeviationViews/Thumb/Standard';
import MobileThumb, { EXTRAS_HEIGHT as MOBILE_EXTRAS_HEIGHT, } from '../../DeviationViews/Thumb/Mobile';
var DeviationGrid = function (_a) {
    var items = _a.items, adjustHeight = _a.adjustHeight, cookieType = _a.cookieType, contentStrip = _a.contentStrip, contentStripIndex = _a.contentStripIndex, contentStripHeight = _a.contentStripHeight, enableScrollOptim = _a.enableScrollOptim, spacing = _a.spacing, allowMobileCardProp = _a.allowMobileCard;
    var isMobile = useContext(MobileContext);
    var isBrowseV2Mobile = useFlag('browsev2_mobile_thumbs');
    var allowMobileCard = allowMobileCardProp && isMobile && isBrowseV2Mobile;
    var getGridItemId = useCallback(function (index) {
        var item = items[index];
        return "item-".concat(item.typeId, "-").concat(item.deviationId);
    }, [items]);
    var getDuperbrowseItemId = useCallback(function (index) {
        return getStreamItemId(items[index]);
    }, [items]);
    var renderGridItem = useCallback(function (element) {
        var index = element.index, width = element.width, height = element.height, style = element.style;
        var item = items[index];
        if (!item) {
            return;
        }
        if (allowMobileCard) {
            return (React.createElement(MobileThumb, { key: getGridItemId(index), deviation: item, width: width, height: height, style: style }));
        }
        return (React.createElement(StandardThumb, { key: getGridItemId(index), deviation: item, width: width, height: height, style: style }));
    }, [getGridItemId, items, allowMobileCard]);
    return (React.createElement(StandardGrid, { contentStrip: contentStrip, contentStripIndex: contentStripIndex, contentStripHeight: contentStripHeight, elementCount: items.length, cookieType: cookieType, getElementId: getGridItemId, getDuperbrowseItemId: getDuperbrowseItemId, adjustHeight: allowMobileCard
            ? MOBILE_EXTRAS_HEIGHT + (adjustHeight !== null && adjustHeight !== void 0 ? adjustHeight : 0)
            : adjustHeight, enableScrollOptim: enableScrollOptim, spacing: spacing }, renderGridItem));
};
DeviationGrid.displayName = 'DeviationGrid';
export default DeviationGrid;
//# sourceMappingURL=DeviationGrid.js.map